import { ReactComponent as Clipboard } from './clipboard.svg'

export default Clipboard
